import { useCallback, useState } from "react";
import { MeFlightAlertsService, MeFlightAlertStopResult } from "../../../api/meFlightAlerts.service";

export type StopFlightAlertOutcome =
  | { success: true; result: MeFlightAlertStopResult }
  | { success: false };

export interface UseStopFlightAlertResult {
  stop: (id: string) => Promise<StopFlightAlertOutcome>;
  isStopping: boolean;
}

export const useStopFlightAlert = (): UseStopFlightAlertResult => {
  const [isStopping, setIsStopping] = useState(false);

  const stop = useCallback(async (id: string): Promise<StopFlightAlertOutcome> => {
    setIsStopping(true);
    try {
      const service = new MeFlightAlertsService();
      const result = await service.stopFlightAlert(id);
      return { success: true, result };
    } catch (err) {
      console.error("Failed to stop flight alert", err);
      return { success: false };
    } finally {
      setIsStopping(false);
    }
  }, []);

  return { stop, isStopping };
};
